module.exports = __webpack_public_path__ + "static/img/face14.5fb7228.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faces/face14.jpg
// module id = rf8y
// module chunks = 0